// createContraindicationsSchema.js
import { z } from "zod";

export function createContraindicationsSchema({
  t,
  isConditionsMetForMRTContraindications,
  isConditionsForAdditionalQuestionService,
  phoneNumber,
  shortPhoneNumber,
  email,
}) {
  // Normalize guards to callables
  const isMrtFn =
    typeof isConditionsMetForMRTContraindications === "function"
      ? isConditionsMetForMRTContraindications
      : () => !!isConditionsMetForMRTContraindications;

  const isAdditionalFn =
    typeof isConditionsForAdditionalQuestionService === "function"
      ? isConditionsForAdditionalQuestionService
      : () => !!isConditionsForAdditionalQuestionService;

  return z
    .object({
      contraindicationQuestionIds: z.array(z.union([z.string(), z.number()])).default([]),
    })
    .superRefine((data, ctx) => {
      const ids = data.contraindicationQuestionIds || [];

      // NOT MRT context → NO selections allowed
      if (!isMrtFn()) {
        if (ids.length > 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["contraindicationQuestionIds"],
            message: t
              ? t("validation.contraindicationQuestion", { phoneNumber, shortPhoneNumber })
              : "Kontraindikacijos pasirinkti negalima.",
          });
        }
        return;
      }

      // MRT context → forbid restricted IDs
      const isAdditional = !!isAdditionalFn();
      const restrictedIds = isAdditional ? [1, 2, 3, 4, 5, 6, 7, 8, 9] : [1, 3, 5];

      const hasRestricted = ids.some((id) => restrictedIds.includes(Number(id)));
      if (hasRestricted) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["contraindicationQuestionIds"],
          message: t
            ? (isAdditional
                ? t("validation.additioanlContraindicationQuestion", { shortPhoneNumber, email })
                : t("validation.contraindicationQuestion", { shortPhoneNumber, email }))
            : "Pasirinkta kontraindikacija neleidžiama internetinei registracijai.",
        });
      }
    });
}
